import React, { Component } from 'react';
import { Link, withRouter, Prompt } from 'react-router-dom';
import { connect } from 'react-redux';
import { retrieve, update, reset } from 'actions/company-settings/update';
import { Form, Header, Grid, Message } from 'semantic-ui-react';
import { EssorButton, CompanyListEdit, toast } from 'components';
import Cleave from 'cleave.js/react';
import { percentageFormat, inputFormat } from 'utils/formatter';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

class VatRates extends Component {
  state = {
    value: {},
    label: '',
    rate: '',
    defaultBool: false,
    labelError: false,
    rateError: false,
    isSettingsLoaded: false,

    btnSave: false,

    hasDataChanged: false,
  };

  componentDidMount() {
    const { retrieve, selectedCompany } = this.props;

    retrieve(`/company_settings?company=${selectedCompany.id}&name=VAT_RATES`);
  }

  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.retrieved && nextProps.retrieved['hydra:member'][0].name === 'VAT_RATES' && !prevState.isSettingsLoaded) {
      return {
        isSettingsLoaded: true,
        value: nextProps.retrieved['hydra:member'][0].value,
      };
    }

    if (prevState.hasDataChanged) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }

    return null;
  }

  handleTextChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleFloatChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    this.setState({
      [name]: inputFormat(value),
    });
  };

  handleCheckBoxChange = (e) => {
    e.preventDefault();

    this.setState(prevState => (
      {
        defaultBool: !prevState.defaultBool,
        hasDataChanged: true,
      }
    ));
  };

  handleAddItem = () => {
    const {
      label,
      rate,
      value,
      rateCleave,
    } = this.state;

    let { defaultBool } = this.state;

    this.setState({
      labelError: false,
      rateError: false,
    });

    let isValid = true;

    if (label.trim() === '') {
      isValid = false;

      this.setState({
        labelError: true,
      });
    }

    if (rate.trim() === '') {
      isValid = false;

      this.setState({
        rateError: true,
      });
    }

    if (!isValid) return;

    if (isEmpty(value)) {
      defaultBool = true;
    }

    if (defaultBool) {
      value.forEach((item) => { item.default = false; });
    }

    const data = {
      label,
      rate: inputFormat(rate),
      default: defaultBool,
    };

    value.push(data);

    this.setState({
      value,
      label: '',
      rate: '',
      defaultBool: false,
      hasDataChanged: true,
    });

    rateCleave.setRawValue('');
  };

  cleanRate = (cleave) => {
    this.setState({
      rateCleave: cleave,
    });
  };

  handleDelete = (e) => {
    const { value } = this.state;
    const index = e.target.getAttribute('data-id');

    value.splice(index, 1);

    this.setState({
      value,
    });
  };

  handleOnSubmit = () => {
    const { value } = this.state;

    const { update, retrieved, history, t } = this.props;

    value.forEach((item) => {
      item.rate = inputFormat(item.rate);
    });

    const data = {
      value,
    };

    this.setState({
      hasDataChanged: false,
    });

    update(retrieved['hydra:member'][0], data)
      .then(() => {
        toast.success(t('varRatesUpdateSuccess'));
        history.push('/company/settings/vat-rates');
      });

    this.setState({
      hasDataChanged: false,
    });
  };

  onSubmitList = (item, hasDataChanged) => {
    this.setState({
      value: item,
      hasDataChanged,
    });
  };

  render() {
    const {
      label,
      rate,
      defaultBool,
      labelError,
      rateError,
      value,
      btnSave,
      hasDataChanged,
    } = this.state;

    const { retrieveLoading, updateLoading, updateError, t } = this.props;

    const callbacks = {
      func: value => percentageFormat(value),
    };

    return (
      <div className="section-container">
        <div className="section-general">
          <Prompt
            when={hasDataChanged}
            message={t('warningYouHaveUnsavedData')}
          />
          <div className="option-buttons-container clearfix">
            <Header as="h3">{t('companiesVatRates')}</Header>
            <EssorButton as={Link} to="/company/settings/vat-rates" type="chevron left" size="tiny" floated="right">
              {t('buttonBack')}
            </EssorButton>
          </div>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form className="margin-top-bot main-form" loading={retrieveLoading || updateLoading} size="small">
                  <Form.Group inline>
                    <Form.Input
                      label={t('formLabel')}
                      name="label"
                      placeholder={t('formPHLabel')}
                      value={label}
                      onChange={this.handleTextChange}
                      error={labelError}
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Input
                      label={t('formRate')}
                      error={rateError}
                    >
                      <Cleave
                        value={inputFormat(rate, true)}
                        name="rate"
                        onInit={this.cleanRate}
                        placeholder={t('formPHRate')}
                        onChange={e => this.handleFloatChange(e)}
                        autoComplete="off"
                        options={{
                          numeralDecimalMark: ',',
                          numeral: true,
                          numeralDecimalScale: 2,
                          numeralPositiveOnly: true,
                        }}
                      />
                    </Form.Input>
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Checkbox
                      label={t('formDefault')}
                      name="defaultBool"
                      checked={defaultBool}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Form.Group>

                  {updateError
                    && (
                      <Message negative>
                        <p>{updateError}</p>
                      </Message>
                    )
                  }
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <div className="clearfix">
            <EssorButton type="plus" onClick={this.handleAddItem} size="tiny" floated="right">
              {t('buttonSubmit')}
            </EssorButton>
          </div>

          {
            !isEmpty(value)
            && (
              <React.Fragment>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={14}>
                      <Form className="margin-top-bot main-form" loading={retrieveLoading || updateLoading} size="small">
                        <CompanyListEdit
                          dataValue={value}
                          format={callbacks}
                          align="format-number-fr"
                          keyWord="rate"
                          onEditList={valueEdit => this.onSubmitList(valueEdit)}
                          btnSave={btnSave}
                          loading={updateLoading}
                          inputsNumeric={[1]}
                        />
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>

                <div className="clearfix">
                  <EssorButton type="check" onClick={this.handleOnSubmit} size="tiny" floated="right">
                    {t('buttonSave')}
                  </EssorButton>
                </div>
              </React.Fragment>
            )
          }
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  retrieve: id => dispatch(retrieve(id)),
  update: (item, values) => dispatch(update(item, values)),
  reset: () => {
    dispatch(reset());
  },
});

const mapStateToProps = state => ({
  retrieveError: state.companySettings.update.retrieveError,
  retrieveLoading: state.companySettings.update.retrieveLoading,
  updateError: state.companySettings.update.updateError,
  updateLoading: state.companySettings.update.updateLoading,
  retrieved: state.companySettings.update.retrieved,
  updated: state.companySettings.update.updated,
  selectedCompany: state.userCompanies.select.selectedCompany,
});


const Main = connect(mapStateToProps, mapDispatchToProps)(VatRates);

export default withTranslation()(withRouter(Main));
